// IIFE entry (dist/main.js) for HTML consumers - the successor of v1's
// window.myApp bundle. Exposes the whole ESM API as window.martinus,
// auto-initializes the standard behavior set on DOMContentLoaded and fires
// martinus:init / martinus:loaded on document.
//
// A consumer can pre-seed configuration before this bundle loads:
//   <script>window.martinusConfig = { select: { language: 'cz' } }</script>
// or skip auto-init entirely with `window.martinusConfig = false` and call
// window.martinus.initAll() itself.

import * as api from './index';

type MartinusGlobal = typeof api & {
  /** Instances created by the auto-init (null before martinus:loaded). */
  instances: api.Instances | null;
};

declare global {
  interface Window {
    martinus: MartinusGlobal;
    martinusConfig?: api.InitOptions | false;
  }
}

const boot = (): void => {
  window.martinus = { ...api, instances: null };

  document.dispatchEvent(new CustomEvent(api.INIT_EVT, { bubbles: true }));

  if (window.martinusConfig !== false) {
    window.martinus.instances = api.initAll(window.martinusConfig ?? {});
  }

  document.dispatchEvent(new CustomEvent(api.LOADED_EVT, { bubbles: true }));
};

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
